export default [
    {
        field: 'acc_account_type_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Tipo',
        },
        options: {
            data: [],
            text: acc_account_type => acc_account_type.code + ' - ' + acc_account_type.comment,
            value: 'id',
        },
    },
    {
        field: 'acc_parent_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Categoría',
        },
        options: {
            data: [],
            text: acc_account => acc_account.code + ' - ' + acc_account.comment,
            value: 'id',
        },
    },
    {
        field: 'code',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Código',
        },
    },
    {
        field: 'comment',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Glosa',
        },
    },
]
